// ../components/config.ts
export const SIDEBAR_WIDTH = 250;
export const SIDEBAR_COLLAPSED_WIDTH = 60;
export const HEADER_HEIGHT = 64;
